/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { MdOutlinePermPhoneMsg } from "react-icons/md";
import { TbFileDownload } from "react-icons/tb";
import moment from "moment-timezone";
import { Data, DataItem, useOperador } from "../../../context/OperadorContext";
import { Loader } from "../../generics/loader";
import { formatMoney } from "../../../utils/formatMoney";
import { useDividas } from "../../../context/DividasContext";
import { useModal } from "../../../hooks/ModalContext";
import { IoMdClose } from "react-icons/io";
import ExcelJS from "exceljs";
import { Spinner } from "../../../components/Spinner";
import { formatCPFCNPJ } from "../../../utils/formatCPFCNPJ";
import { errorAlert } from "../../../components/Alerts/Error";
import { isAfter, isToday } from "date-fns";
import { useAuth } from "../../../context/AuthContext";
import { Input } from "../ui/input"
import { Button } from "../ui/button"
import { Search, X, MessageCircle, Download, ChevronUp, ChevronDown } from "lucide-react"
import { WhatsAppCampaignModal } from '../modal-whatsapp'
import { ModalErrorTotalClientes } from '../modal-whatsapp/modal-error-total-clientes'
import { Checkbox } from "../ui/checkbox";
import { Clientes, useWhatsAppCampaign } from "../../../context/WhatsAppCampaignContext";

// import { format } from 'date-fns'


interface TabelaCobrancaProps {
  data: Data | null;
  loading: boolean;
  handleOpenTab: (value: string) => void;
  isOperadorLojaAntigo?: boolean
}

export default function TabelaCobranca({
  data,
  loading,
  handleOpenTab,
  isOperadorLojaAntigo
}: TabelaCobrancaProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const { setModal } = useModal();
  const [nameCliente, setNameCliente] = useState("");
  const [filterName, setFilterName] = useState("");

  const {
    selectedClients,
    setSelectedClients,
    queueLimit,
    setQueueLimit,
    isModalOpen,
    setIsModalOpen,
    applyQueueLimit,
    setVisibleClients,
    visibleClients,
    selectClientsByCpf,
    setSkippedTodayClients,
    skippedTodayClients
  } = useWhatsAppCampaign()

  const [ordem, setOrdem] = useState('')
  const { getDividasGazin, devedor, clearDividas } = useDividas();
  const { loadData, filtros, page, setPage } = useOperador();
  const { cookies } = useAuth()
  const [filas, setFilas] = useState<number>(0);

  const [tabelaData, setTabelaData] = useState(data?.data.map((dat) => ({
    ...dat,
    valor_vencido: dat.valor_vencido ? formatMoney(dat.valor_vencido) : "-",
    data_ultimo_acionamento: dat.data_ultimo_acionamento
      ? moment(new Date(dat.data_ultimo_acionamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    data_agendamento: dat.data_agendamento
      ? moment(new Date(dat.data_agendamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    data_ultimo_whatsapp: dat.data_ultimo_whatsapp
      ? moment(new Date(dat.data_ultimo_whatsapp))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    button: <MdOutlinePermPhoneMsg />,
  })))

  const newData = data?.data.map((dat) => ({
    ...dat,
    valor_vencido: dat.valor_vencido ? formatMoney(dat.valor_vencido) : "-",
    data_ultimo_acionamento: dat.data_ultimo_acionamento
      ? moment(new Date(dat.data_ultimo_acionamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    data_agendamento: dat.data_agendamento
      ? moment(new Date(dat.data_agendamento))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    data_ultimo_whatsapp: dat.data_ultimo_whatsapp
      ? moment(new Date(dat.data_ultimo_whatsapp))
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY")
      : "-",
    button: <MdOutlinePermPhoneMsg />,
  }))

  function isToday(data: string | Date) {
    if (!data) return false;

    return moment(data, "DD/MM/YYYY", true).isSame(moment(), "day");
  }


  async function downloadCSV() {
    const rightAlign = [6, 7];
    setIsLoading(true);
    let arrayData: Data | undefined;
    try {
      arrayData = await loadData({
        ...filtros,
        page: 0,
      });
    } catch (error) {
      errorAlert();
      setIsLoading(false);
    }
    if (!arrayData) {
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Relatório Completo");
    const header = sheet.addRow([
      "Data Lista",
      "Assessoria",
      "Id Loja",
      "Vendedor",
      "Atraso",
      "Valor Vencido",
      "Valor a Vencer",
      "Ultimo Acionamento",
      "Data Agendamento",
      "Id Processo",
      "CPF/CNPJ Cliente",
      "Cliente",
      "Telefone Móvel 1",
      "Telefone Móvel 2",
      "Telefone Móvel 3",
      "Telefone Móvel 4",
      "Telefone Móvel 5",
      "Telefone Móvel Ref 1",
      "Telefone Móvel Ref 2",
      "Telefone Móvel Ref 3",
      "Email",
      'UF',
      'Cidade',
      'Bairro',
      'Logradouro',
      'Numero',
      'Complemento',
    ]);
    header.eachCell((cell) => {
      cell.style = {
        font: {
          bold: true,
        },
      };
    });

    for (const item of arrayData.data) {
      sheet.addRow([
        item?.data_lista
          ? moment(new Date(item.data_lista))
            .tz("America/Sao_Paulo")
            .format("DD/MM/YYYY")
          : "",

        item.assessoria ?? "",
        item.loja ?? "",
        item.nome_vendedor,
        item.atraso ?? "",
        formatMoney(item.valor_vencido ?? 0),
        formatMoney(item.valor_a_vencer ?? 0),
        item.data_ultimo_acionamento
          ? moment(new Date(item.data_ultimo_acionamento))
            .tz("America/Sao_Paulo")
            .format("DD/MM/YYYY")
          : "",
        item.data_agendamento
          ? moment(new Date(item.data_agendamento))
            .tz("America/Sao_Paulo")
            .format("DD/MM/YYYY")
          : "",
        item.id_processo ?? "",
        item.cpf_cnpj ? formatCPFCNPJ(item.cpf_cnpj) : "",
        item.nome_cliente ?? "",
        item?.fone1 ?? "",
        item?.fone2 ?? "",
        item?.fone3 ?? "",
        item?.fone4 ?? "",
        item?.fone5 ?? "",
        item?.fone6 ?? "",
        item?.fone7 ?? "",
        item?.fone8 ?? "",
        item?.email ?? "",
        item?.uf ?? "",
        item?.cidade ?? "",
        item?.bairro ?? "",
        item?.logradouro ?? "",
        item?.numero ?? "",
        item?.complemento ?? "",
      ]);
    }
    sheet.eachRow((row) => {
      row.eachCell((cell, col) => {
        if (rightAlign.includes(col)) {
          cell.alignment = { horizontal: "right" };
        } else {
          cell.alignment = { horizontal: "left" };
        }
      });
    });
    sheet.columns.forEach((column) => {
      const lengths = column?.values?.map((v) => (v ?? 0).toString().length);
      const maxLength = Math.max(
        ...(lengths ?? []).filter((v) => typeof v === "number")
      );

      column.width = maxLength + 5;
      column?.eachCell &&
        column.eachCell((cell) => {
          cell.font = {
            ...cell.font,
            name: "Calibri",
          };
        });
    });

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const date = new Date().getDate();
        link.setAttribute("download", `Relatório dia ${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error generating Excel file:", error);
        errorAlert();
      })
      .finally(() => setIsLoading(false));
  }
  const handleNextPage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (page > 1) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  async function handleDoubleClick(cpf_cnpj: string, id: number) {
    setSpinner(true);
    try {
      clearDividas()
      handleOpenTab("atendimento");
      await getDividasGazin({ cpf_cnpj, id, app: 'ACIONA_OPE', usuario: String(cookies?.user?.id_operador), });

    } catch (err) {
      setModal(
        "Falha ao selecionar  o cliente! Tente novamente mais tarde",
        "Erro",
        false,
        true
      );
      // console.log("esse erro aqui", err);
    } finally {
      setSpinner(false);
    }
  }

  const [sortField, setSortField] = useState<
    | "nome"
    | "processo"
    | "vendedor"
    | "diasAtraso"
    | "valorVencido"
    | "ultimoAcionamento"
    | "envioWhatsapp"
    | "agendamento"
    | null
  >(null)
  const [sortDirection, setSortDirection] = useState<"asc" | "desc" | null>(null)



  const handleSort = (
    field:
      | "nome"
      | "processo"
      | "vendedor"
      | "diasAtraso"
      | "valorVencido"
      | "ultimoAcionamento"
      | "envioWhatsapp"
      | "agendamento",
  ) => {
    if (sortField === field) {
      // Toggle direction: asc -> desc -> null
      if (sortDirection === "asc") {
        setSortDirection("desc")
      } else if (sortDirection === "desc") {
        setSortDirection(null)
        setSortField(null)
      }
    } else {
      setSortField(field)
      setSortDirection("asc")
    }
  }

  const getSortedClients = () => {
    if (!sortField || !sortDirection) return tabelaData

    if (!tabelaData) return

    const sorted = [...tabelaData].sort((a, b) => {
      let aValue: any
      let bValue: any

      switch (sortField) {
        case "nome":
          aValue = a.nome_cliente.toLowerCase()
          bValue = b.nome_cliente.toLowerCase()
          break
        case "processo":
          aValue = Number.parseInt(a.id_processo)
          bValue = Number.parseInt(b.id_processo)
          break
        case "vendedor":
          aValue = a.nome_vendedor.toLowerCase()
          bValue = b.nome_vendedor.toLowerCase()
          break
        case "diasAtraso":
          aValue = a.atraso
          bValue = b.atraso
          break
        case "valorVencido":
          aValue = Number.parseFloat(a.valor_vencido.replace("R$ ", "").replace(".", "").replace(",", "."))
          bValue = Number.parseFloat(b.valor_vencido.replace("R$ ", "").replace(".", "").replace(",", "."))
          break
        case "ultimoAcionamento":
          aValue = a.data_ultimo_acionamento === "-" ? "" : a.data_ultimo_acionamento.split("/").reverse().join("")
          bValue = b.data_ultimo_acionamento === "-" ? "" : b.data_ultimo_acionamento.split("/").reverse().join("")
          break
        case "envioWhatsapp":
          aValue = a.data_ultimo_acionamento === "-" ? "" : a.data_ultimo_whatsapp.split("/").reverse().join("")
          bValue = b.data_ultimo_acionamento === "-" ? "" : b.data_ultimo_whatsapp.split("/").reverse().join("")
          break
        case "agendamento":
          aValue = a.data_agendamento === "-" ? "" : a.data_agendamento.split("/").reverse().join("")
          bValue = b.data_agendamento === "-" ? "" : b.data_agendamento.split("/").reverse().join("")
          break
        default:
          return 0
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1
      return 0
    })

    return sorted
  }

  const renderSortIcon = (
    field:
      | "nome"
      | "processo"
      | "vendedor"
      | "diasAtraso"
      | "valorVencido"
      | "ultimoAcionamento"
      | "envioWhatsapp"
      | "agendamento",
  ) => {
    const isActive = sortField === field
    return (
      <div className="flex flex-col">
        <ChevronUp className={`h-3 w-3 ${isActive && sortDirection === "asc" ? "text-blue-600" : "text-gray-400"}`} />
        <ChevronDown
          className={`h-3 w-3 -mt-1 ${isActive && sortDirection === "desc" ? "text-blue-600" : "text-gray-400"}`}
        />
      </div>
    )
  }

  const toggleClientSelection = (cpf: string) => {
    const newSelected = new Set(selectedClients)
    if (newSelected.has(cpf)) {
      newSelected.delete(cpf)
    } else {
      newSelected.add(cpf)
    }
    setSelectedClients(newSelected)
  }


  const toggleAllClients = () => {
    if (!tabelaData || tabelaData.length === 0) return

    const selecionaveis = tabelaData.filter(
      c => !isToday(c.data_ultimo_whatsapp)
    )

    let pulados = tabelaData.filter(
      c => isToday(c.data_ultimo_whatsapp)
    )

    const visibleCpfs = selecionaveis.map(c => c.cpf_cnpj)

    const allVisibleSelected = visibleCpfs.every(cpf =>
      selectedClients.has(cpf)
    )

    let nextSelection: string[]

    if (allVisibleSelected) {
      nextSelection = []
      pulados = []
    } else {
      nextSelection = visibleCpfs
    }

    selectClientsByCpf(nextSelection)

    setSkippedTodayClients(pulados.map(c => c.cpf_cnpj))

    setQueueLimit('')
  }


  const getClientsToSend = () => {
    if (tabelaData) {
      return selectedClients.size > 0 ? selectedClients.size : tabelaData.length
    }
    return 0
  }

  const clientesElegiveis =
    tabelaData?.filter(c => !isToday(c.data_ultimo_whatsapp)) ?? []

  const allSelected =
    clientesElegiveis.length > 0 &&
    clientesElegiveis.every(c =>
      selectedClients.has(c.cpf_cnpj)
    )


  const sortedClients = getSortedClients()

  const filaSelecionada = useMemo<DataItem[]>(() => {
    if (!data?.data) return []

    if (selectedClients.size === 0) {
      return [] as DataItem[]
    }

    return data.data.filter(item =>
      selectedClients.has(item.cpf_cnpj)
    )
  }, [data?.data, selectedClients])



  function toggleSelectWhats(cpf_cnpj: string, data_whats: string) {
    if (data_whats && isToday(data_whats)) {
      return
    }
    toggleClientSelection(cpf_cnpj)
  }


  function handleSearch() {
    setFilterName(nameCliente)

    const filtered = tabelaData?.filter((dat) =>
      dat.nome_cliente
        ?.toLocaleLowerCase()
        .includes(nameCliente?.toLocaleLowerCase())
    )

    setTabelaData(filtered)

    if (filtered) {
      const visibleCpfs = new Set(filtered.map(c => c.cpf_cnpj))
      const newSelected = new Set<string>()

      selectedClients.forEach(cpf => {
        if (visibleCpfs.has(cpf)) {
          newSelected.add(cpf)
        }
      })

      setSelectedClients(newSelected)
    }
  }


  function handleClearSearch() {
    setFilterName("");
    setNameCliente("");
    setTabelaData(newData)
    if (newData && newData.length > 0) {
      selectClientsByCpf(newData.map(c => c.cpf_cnpj))
    } else {
      setSelectedClients(new Set())
    }
  }


  useEffect(() => {
    setTabelaData(newData)
  }, [data])

  useEffect(() => {
    if (!queueLimit) return
    if (!visibleClients.length) return

    applyQueueLimit()
  }, [queueLimit, visibleClients])

  useEffect(() => {
    if (sortedClients && sortedClients.length > 0) {
      setVisibleClients(sortedClients)
    }
  }, [sortedClients])

  useEffect(() => {

    if (data?.data?.length === 0) {
      return;
    }
    // const hoje = new Date().toISOString().split('T')[0];

    const totalFilaLoja = data?.data.length ?? 0;

    setFilas(totalFilaLoja);
  }, [data]);



  return (
    <div className="flex h-[100vh] w-[100%] items-center justify-center overflow-y-hidden pb-10">
      {!data || loading || spinner ? (
        <div className="flex h-[20rem] w-full items-center justify-center">
          <Loader />
        </div>
      ) : (
        <>
          {data.data.length < 1 ? (
            <div className="w-full p-10 text-center">
              <p className="text-2xl font-bold text-coolGray-700">
                Não existe fila para esta seleção, verifique os filtros ou o
                operador.
              </p>
            </div>
          ) : (
            <div className=" flex h-[100%] w-full flex-col justify-between ">
              <div className="relative h-full flex items-center justify-between  w-full">
                <div className="my-2 flex items-center justify-between space-x-2  bg-white">

                  <div className="relative flex items-center">
                    <Input
                      placeholder="Digite o nome do cliente"
                      value={nameCliente}
                      onChange={(e) => setNameCliente(e.target.value)}
                      className="w-64 h-9 pr-16"
                    />
                    <div className="absolute right-1 flex gap-1">
                      <Button size="sm" className="h-7 w-7 p-0 bg-blue-600 hover:bg-blue-700" onClick={handleSearch}>
                        <Search className="h-4 w-4 text-white" />
                      </Button>
                      <Button size="sm" variant="outline" className="h-7 w-7 p-0 bg-transparent" onClick={handleClearSearch}>
                        <X className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                  <div className="bg-blue-50 px-4 py-2 rounded-lg border border-blue-200">
                    <span className="text-sm font-semibold text-blue-600">{selectedClients.size}</span>
                    <span className="text-sm text-gray-600 ml-1">clientes selecionados</span>
                  </div>
                  <div className="bg-green-50 px-4 py-2 rounded-lg border border-green-200">
                    <span className="text-sm font-semibold text-green-600">{skippedTodayClients.length}</span>
                    <span className="text-sm text-gray-600 ml-1">com envio WhatsApp</span>
                  </div>
                </div>
                <div className="flex items-center gap-4">



                  <button className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900" onClick={downloadCSV}>
                    Baixar relatório completo
                    <Download className="h-4 w-4" />
                  </button>
                </div>
              </div>

              <div className="border rounded-lg max-h-[200px]">
                <div className="max-h-[200px] overflow-y-auto">
                  <table className="w-full  rounded-lg">
                    <thead className="sticky top-0 z-10 bg-blue-50">
                      <tr>
                        <th className="w-[50px] bg-blue-50 h-10 text-left px-4">
                          <div className="flex items-center justify-center">
                            <Checkbox className="h-5 w-5 " checked={allSelected} onCheckedChange={toggleAllClients} aria-label="Selecionar todos" />
                          </div>
                        </th>
                        <th className="w-[130px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4">CPF</th>
                        <th
                          className="w-[250px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("nome")}
                        >
                          <div className="flex items-center gap-1">
                            Nome cliente
                            {renderSortIcon("nome")}
                          </div>
                        </th>
                        <th
                          className="w-[90px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("processo")}
                        >
                          <div className="flex items-center gap-1">
                            Processo
                            {renderSortIcon("processo")}
                          </div>
                        </th>
                        <th
                          className="w-[200px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("vendedor")}
                        >
                          <div className="flex items-center gap-1">
                            Nome vendedor
                            {renderSortIcon("vendedor")}
                          </div>
                        </th>
                        <th
                          className="w-[100px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-right px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("diasAtraso")}
                        >
                          <div className="flex items-center justify-end gap-1">
                            Dias atraso
                            {renderSortIcon("diasAtraso")}
                          </div>
                        </th>
                        <th
                          className="w-[120px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-right px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("valorVencido")}
                        >
                          <div className="flex items-center justify-end gap-1">
                            Valor vencido
                            {renderSortIcon("valorVencido")}
                          </div>
                        </th>
                        <th className="w-[140px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4">
                          Assessoria
                        </th>
                        <th className="w-[150px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4">
                          Classificação
                        </th>
                        <th
                          className="w-[140px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("ultimoAcionamento")}
                        >
                          <div className="flex items-center gap-1">
                            Último acionamento
                            {renderSortIcon("ultimoAcionamento")}
                          </div>
                        </th>
                        <th
                          className="w-[120px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("envioWhatsapp")}
                        >
                          <div className="flex items-center gap-1">
                            Envio WhatsApp
                            {renderSortIcon("envioWhatsapp")}
                          </div>
                        </th>
                        <th
                          className="w-[120px] text-xs font-semibold text-gray-900 bg-blue-50 h-10 text-left px-4 cursor-pointer hover:bg-blue-100"
                          onClick={() => handleSort("agendamento")}
                        >
                          <div className="flex items-center gap-1">
                            Agendamento
                            {renderSortIcon("agendamento")}
                          </div>
                        </th>
                      </tr>
                    </thead>
                    {/* </table> */}
                    {/* </div> */}

                    {/* <div className="max-h-[300px] overflow-y-auto"> */}
                    {/* <table className="w-full table-fixed"> */}
                    <tbody >
                      {sortedClients && sortedClients.length > 0 && sortedClients.map((client, index) => (
                        <tr key={client.id_lista_loja}
                          onDoubleClick={() =>
                            handleDoubleClick(client.cpf_cnpj, client.id_lista_loja)
                          } className={`hover:bg-gray-50 border-b border-gray-100 min-h-[2rem] cursor-pointer ${Number(devedor.id_debtor) === client.id_lista_loja
                            ? "bg-blue-50"
                            : ""
                            }`}>
                          <td className="w-[50px] px-4 py-3">
                            <div className="flex items-center justify-center">
                              <Checkbox
                                className="h-5 w-5 pointer-events-auto"
                                checked={selectedClients.has(client.cpf_cnpj)}
                                onCheckedChange={() => toggleSelectWhats(client.cpf_cnpj, client.data_ultimo_whatsapp)}
                                aria-label={`Selecionar ${client.nome_cliente}`}
                              />
                            </div>
                          </td>
                          <td className="w-[130px] text-xs text-blue-600 font-medium px-4 py-3 pointer-events-none">{formatCPFCNPJ(client.cpf_cnpj || '')}</td>
                          <td className="w-[250px] text-xs px-4 py-3">{client.nome_cliente}</td>
                          <td className="w-[90px] text-xs text-blue-600 px-4 py-3">{client.id_processo}</td>
                          <td className="w-[200px] text-xs text-blue-600 px-4 py-3">{client.nome_vendedor}</td>
                          <td className="w-[100px] text-xs text-right px-4 py-3">{client.atraso}</td>
                          <td className="w-[120px] text-xs text-right px-4 py-3">{client.valor_vencido}</td>
                          <td className="w-[140px] text-xs px-4 py-3">{client.assessoria}</td>
                          <td className="w-[150px] text-xs px-4 py-3">{client.classificacao}</td>
                          <td className="w-[140px] text-xs px-4 py-3">{client.data_ultimo_acionamento}</td>
                          <td
                            className={`w-[120px] text-xs px-4 py-3 ${client.data_ultimo_whatsapp && isToday(client.data_ultimo_whatsapp)
                              ? 'bg-green-200'
                              : ''
                              }`}
                          >
                            {client.data_ultimo_whatsapp}
                          </td>
                          <td className="w-[120px] text-xs px-4 py-3">{client.data_agendamento}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {
                data?.orcamento_diario.utility_disponivel < getClientsToSend() ? (
                  <ModalErrorTotalClientes open={isModalOpen}
                    onOpenChange={setIsModalOpen}
                    totalClients={getClientsToSend()} disponivel={data?.orcamento_diario.utility_disponivel} />

                ) : (

                  <WhatsAppCampaignModal
                    open={isModalOpen}
                    onOpenChange={setIsModalOpen}
                    totalClients={getClientsToSend()}
                    fila={filaSelecionada}
                  />
                )
              }
            </div>
          )}
        </>
      )}
    </div>
  );
}
